


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { Organization } from '@/common/Organizations';

import { CleanID } from '@/utils/Utils';

import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import Welcome from '@/components/Global/Welcome.vue';
import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

import MainTab from '@/components/Staff/OrgManagement/Tabs/Main.vue';
import UsersTab from '@/components/Staff/OrgManagement/Tabs/Users.vue';
import InvitesTab from '@/components/Staff/OrgManagement/Tabs/Invites.vue';
import ClaimsTab from '@/components/Staff/OrgManagement/Tabs/Claims.vue';
import ClientIdsTab from '@/components/Staff/OrgManagement/Tabs/ClientIds.vue';

import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
	name: 'Organization',
	components: {
		Welcome,
		TextField,
		SwitchField,
		Loading,
		Alert,
		MainTab,
		UsersTab,
		InvitesTab,
		ClaimsTab,
		ClientIdsTab,
	},
	validations: {
		fields: {
			org_name: {
				required,
			},
			brokerageId: {
				requiredIf: requiredIf(vm => vm.is_agency),
			},
		},
	},
})
export default class OrgManagement extends Vue {
	@State('organization', { namespace: 'Organizations' }) private organization: Organization;
	@Action('updateOrganization', { namespace: 'Organizations' }) private updateOrganization: (
		fields: Organization,
	) => string;

	private currentTab = 'main';
	private fields: Organization = {
		org_id: '',
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		phone_number: '',
	};

	private isInvalid: boolean = false;
	private success: boolean = false;
	private error: boolean = false;
	private loading: boolean = true;

	@Watch('organization')
	private watchOrganization() {
		this.fields = this.organization;
	}

	@Watch('$route', { deep: true })
	private watchRoute(newValue) {
		this.currentTab = this.$route.params.tab;
	}

	private changeTab(tab) {
		this.success = false;
		this.error = false;
		// this.currentTab = tab;

		this.$router.push({
			name: 'stafforganizationtabbed',
			params: {
				org_id: this.$route.params.org_id,
				tab,
			},
		});
	}

	private async created() {
		try {
			await this.$store.dispatch(
				'Organizations/getOrganization',
				this.$route.params.org_id,
			);
			this.loading = false;
			this.currentTab = this.$route.params.tab || 'main';

			console.log(this.organization);
		} catch (e) {
			console.log(e);
		}
	}

	private async updateOrg() {
		this.isInvalid = false;
		this.error = false;
		this.success = false;
		this.$v.$touch();

		if (this.$v.$invalid) {
			this.isInvalid = true;
			return;
		}

		if (this.fields.brokerageId !== '') {
			this.fields.brokerageId = CleanID(this.fields.brokerageId);
		}

		try {
			await this.updateOrganization(this.fields);

			this.success = true;
		} catch (e) {
			this.error = true;
		}
	}
}
